'use client';

import { useEffect } from 'react';

let scrollLockCount = 0;

const applyScrollLock = () => {
    document.body.style.overflow = 'hidden';
    window.document.documentElement.style.setProperty('--toastify-top', '32px');
};

const releaseScrollLock = () => {
    window.document.documentElement.style.setProperty('--toastify-top', '96px');
    document.body.style.overflow = '';
};

/**
 * Reference-counted body scroll lock so a non-locking toast can outlive a locking dialog.
 */
export const useRemoveScroll = (enabled = true) => {
    useEffect(() => {
        if (!enabled) return;

        scrollLockCount += 1;
        if (scrollLockCount === 1) {
            applyScrollLock();
        }

        return () => {
            scrollLockCount = Math.max(0, scrollLockCount - 1);
            if (scrollLockCount === 0) {
                releaseScrollLock();
            }
        };
    }, [enabled]);
};
